export default __webpack_public_path__ + "static/media/upwardTrail.820b80ff.svg";